import React, { useEffect, useState, useContext } from "react";
import api from "../admin/api/api";
import { useParams } from "react-router-dom";
import { PrinterFill } from "react-bootstrap-icons";
import "./Invoice.scss";
import { ShopContext } from "../context/ShopContext";

function Invoice() {

  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const { shop } = useContext(ShopContext);

  useEffect(() => {
    getOrder();
  }, []);

  const getOrder = async () => {

    try {

      const response = await api.get(`/Orders/${orderId}`
      );

      setOrder(response.data);

    } catch (error) {
      console.log(error);
    }

  };

  const printInvoice = () => {
    window.print();
  };

  if (!order) {
    return <h2>Loading Invoice...</h2>;
  }

  return (
    <div className="invoice-container">

      <div className="print-area">

      <div className="invoice-card">

        {/* Header */}
        <div className="invoice-header">

          <div className="company">
            <h2>{shop?.shopName}</h2>
            <p>Fashion for Every Occasion</p>
          </div>

          <div className="invoice-info">
            <h3>INVOICE</h3>
            <p><strong>Order No:</strong> {order.orderNo}</p>
            <p><strong>Date:</strong> {new Date(order.orderDate).toLocaleDateString()}</p>
          </div>

        </div>

        {/* Customer Details */}
        <div className="customer-section">

          <div>
            <h4>Billing Address</h4>
            <p>{order.customerName}</p>
            <p>{order.address}</p>
            <p>{order.city}</p>
            <p>Mobile: {order.mobile}</p>
          </div>

          <div>
            <h4>Payment Method</h4>
            <p>Cash On Delivery</p>
          </div>

        </div>

        {/* Product Table */}
        <table className="invoice-table">

          <thead>
            <tr>
              <th>#</th>
              <th>Product</th>
              <th>Qty</th>
              <th>Price</th>
              <th>Size</th>
              <th>Color</th>
            </tr>
          </thead>

          <tbody>

            {order.items.map((item, index) => (

              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.productName}</td>
                <td>{item.qty}</td>
                <td>₹{item.price}</td>
                <td>{item.size}</td>
                <td>{item.color}</td>
              </tr>

            ))}

          </tbody>

        </table>

        {/* Total */}
        <div className="total-section border-bottom pb-3 border-2">

          <div className="total-box">

            <p>
              <span>Subtotal</span>
              <span>₹{order.totalAmount}</span>
            </p>

            <p>
              <span>Shipping</span>
              <span>₹0</span>
            </p>

            <h3>
              <span>Total</span>
              <span>₹{order.totalAmount}</span>
            </h3>

          </div>

        </div>

        {/* Footer */}
        <div className="invoice-footer">

          <p>Thank you for shopping with {shop?.shopName}</p>

        </div>

      </div>

      {/* Print Button */}
      <div className="print-btn">

        <button onClick={printInvoice}>
          <PrinterFill /> Print Invoice
        </button>

      </div>

    </div>
    </div>
  );
}

export default Invoice;